function initCdcSlider() {
  const slider = document.querySelector('.cdc-slider');
  if (!slider || slider.dataset.cdcInit) return;
  slider.dataset.cdcInit = '1';

  const prevBtn = slider.querySelector('.cdc-slider__arrow--prev');
  const nextBtn = slider.querySelector('.cdc-slider__arrow--next');
  let currentIndex = 0;

  const getPerPage = () => window.innerWidth <= 768 ? 1 : 5;

  function updateSlider() {
    const perPage = getPerPage();
    const items = slider.querySelectorAll('.cdc--product');
    const total = items.length;

    items.forEach((item, i) => {
      item.style.display = (i >= currentIndex && i < currentIndex + perPage) ? 'flex' : 'none';
    });

    prevBtn.disabled = currentIndex === 0;
    nextBtn.disabled = currentIndex + perPage >= total;
  }

  prevBtn.addEventListener('click', () => {
    currentIndex = Math.max(0, currentIndex - getPerPage());
    updateSlider();
  });

  nextBtn.addEventListener('click', () => {
    const total = slider.querySelectorAll('.cdc--product').length;
    currentIndex = Math.min(total - getPerPage(), currentIndex + getPerPage());
    updateSlider();
  });

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      currentIndex = 0;
      updateSlider();
    }, 150);
  });

  updateSlider();
}

(function() {
  const slider = document.querySelector('.cdc-slider');
  if (!slider) return;

  if (slider.querySelector('.cdc--product')) {
    initCdcSlider();
    return;
  }

  const observer = new MutationObserver((mutations, obs) => {
    if (slider.querySelector('.cdc--product')) {
      obs.disconnect();
      initCdcSlider();
    }
  });
  observer.observe(slider, { childList: true, subtree: true });
}());
